import script from "./PaymentConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentConfirm.vue?vue&type=style&index=0&id=36ae6231&scoped=true&lang=css"
import "./PaymentConfirm.vue?vue&type=style&index=1&id=36ae6231&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ae6231"]])

export default __exports__